export const STATISTIC = "statistic";
export const DAYS = "days";
export const TEAM = "team";
export const GREATER_THAN = "greaterThan";
export const PLAYER = "player";
export const SEASON = "season";
export const OPERATION = "operation";
